import axios from "axios";
import settings from "utils/settings";
import defaultErrorHandler from "actions/global/default-error-handler";
import {
  ZONES_LOADING,
  ZONES_ERROR,
  ZONES_LIST
} from "./constants";

const scooterUrl = `${settings.scooterUrl}api/`;
const ENDPOINT = "zones";

export const setLoading = (status) => ({
  type: ZONES_LOADING,
  payload: status
});

export const getList = () => dispatch => {
  dispatch(setLoading(true));
  axios.get(`${scooterUrl}${ENDPOINT}`)
    .then(response => {
      dispatch({
        type: ZONES_LIST,
        payload: response.data
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ZONES_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/scooter/zones/actions.js